export default __webpack_public_path__ + "images/blogIcon.9908cef7f34bd5ef83ef5fb371c82cd6.svg";